import { render, staticRenderFns } from "./ListaDisciplinaDireito.vue?vue&type=template&id=0a50ca1e"
import script from "./ListaDisciplinaDireito.vue?vue&type=script&lang=js"
export * from "./ListaDisciplinaDireito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports